export default __webpack_public_path__ + "static/media/photo--lg--125.ec2785c7.jpg";